// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface INamePropertyDto
 */
export interface INamePropertyDto {
    /**
     * 
     * @type {string}
     * @memberof INamePropertyDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof INamePropertyDto
     */
    name_state?: INamePropertyDtoNameStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum INamePropertyDtoNameStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the INamePropertyDto interface.
 */
export function instanceOfINamePropertyDto(value: object): value is INamePropertyDto {
    return true;
}

export function INamePropertyDtoFromJSON(json: any): INamePropertyDto {
    return INamePropertyDtoFromJSONTyped(json, false);
}

export function INamePropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): INamePropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'name_state': json['name_state'] == null ? undefined : json['name_state'],
    };
}

export function INamePropertyDtoToJSON(json: any): INamePropertyDto {
    return INamePropertyDtoToJSONTyped(json, false);
}

export function INamePropertyDtoToJSONTyped(value?: INamePropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'name_state': value['name_state'],
    };
}

